import { useNavigation } from 'modules/core/hooks/useNavigation'

import CollectionsBootstrap from 'modules/custom_resources/lib/ProfileCollectionsBootstrap'
import CustomTablesListPage from 'modules/employees/pages/CustomTablesListPage'

const Container = () => {
  const { navigation } = useNavigation()

  return (
    <CustomTablesListPage
      rootRoute={{
        customTablesIndex: () => navigation.profile.customTables.fullPath(),
        customTablesDelete: (schemaId: string, valueId: string) =>
          navigation.profile.customTables.schemaIdValuesValueIdDelete.fullPath({
            schemaId,
            valueId,
          }),
        customTablesEdit: (schemaId: string, valueId: string) =>
          navigation.profile.customTables.schemaIdValuesValueIdEdit.fullPath({ schemaId, valueId }),
        customTablesNew: (schemaId: string) =>
          navigation.profile.customTables.schemaIdNew.fullPath({ schemaId }),
      }}
    />
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
